import { backendApi } from "@/services/backend/api";
import { Sequence } from "@/services/backend/numbers/types/sequence";
import { DocumentNumber } from "@/services/backend/numbers/types/document-number";
import { DocumentKind } from "@bitory-gmbh/bsm";
import { Filter } from "@/shared/lib/filter/filter";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";

const documentNumberApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["NumbersDocumentNumberSequence", "NumbersDocumentNumber"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      numbersDocumentNumberCreateSequence: build.mutation<
        Sequence,
        CreateSequenceRequest
      >({
        query: (request) => ({
          url: `/numbers/document-number/sequence`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: ["NumbersDocumentNumberSequence"],
      }),
      numbersDocumentNumberShowSequence: build.query<
        Sequence,
        ShowSequenceRequest
      >({
        query: (request) => ({
          url: `/numbers/document-number/sequence`,
          method: "GET",
          params: request,
        }),
        providesTags: (_result, _e, request) => [
          {
            type: "NumbersDocumentNumberSequence",
            id: request.documentKind + request.companyId,
          },
        ],
      }),
      numbersDocumentNumberShow: build.query<DocumentNumber, ShowRequest>({
        query: (request) => ({
          url: `/numbers/document-number`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) => [
          result
            ? { type: "NumbersDocumentNumber", id: result.documentId }
            : "NumbersDocumentNumber",
        ],
      }),
      numbersDocumentNumberList: build.query<List, ListRequest>({
        query: (request) => ({
          url: `/numbers/document-number/list`,
          method: "GET",
          params: { request: btoa(JSON.stringify(request)) },
        }),
      }),
    }),
  });

export const {
  useNumbersDocumentNumberCreateSequenceMutation,
  useNumbersDocumentNumberShowSequenceQuery,
  useNumbersDocumentNumberShowQuery,
  useNumbersDocumentNumberListQuery,
} = documentNumberApi;

export interface CreateSequenceRequest {
  documentKind: string;
  companyId: string;
  start: number;
}

export interface ShowSequenceRequest {
  documentKind: DocumentKind;
  companyId: string;
}

export interface ShowRequest {
  documentId: string;
}

export interface ListRequest {
  documentKind?: Filter<DocumentKind>;
  serviceKind?: Filter<GSMServiceKind>;
  company?: Filter<string>;
  string?: Filter<string>;
  offset?: number;
  limit?: number;
}

export interface List {
  numbers: DocumentNumber[];
  count: number;
  offset: number;
  totalCount: number;
}
